import styled from "styled-components";

export type StatusBadgeTone =
  | "positive"
  | "attention"
  | "info"
  | "neutral"
  | "muted";

// Each tone is one colour: the text takes it at full strength, the fill and
// border are tints of it, so a new tone needs a single value.
const TONE_COLORS: Record<StatusBadgeTone, string> = {
  positive: "var(--chip-text-success)",
  attention: "var(--ping-text-color-warning)",
  info: "var(--brand-purple-700)",
  neutral: "var(--brand-gray-700)",
  muted: "var(--brand-gray-600)",
};

const BadgeStyled = styled.span<{ $tone: StatusBadgeTone }>`
  padding: 0.375rem 0.75rem;

  border-radius: 999px;
  background-color: ${({ $tone }) =>
    `color-mix(in srgb, ${TONE_COLORS[$tone]} 12%, var(--brand-white))`};
  border: 1px solid
    ${({ $tone }) =>
      `color-mix(in srgb, ${TONE_COLORS[$tone]} 35%, var(--brand-white))`};

  color: ${({ $tone }) => TONE_COLORS[$tone]};
  font-size: 0.8125rem;
  font-weight: var(--font-weight-medium);
  white-space: nowrap;

  .p-badge-icon {
    font-size: 0.875rem;
  }
`;

export function StatusBadge({
  label,
  tone,
  icon,
}: {
  label: string;
  tone: StatusBadgeTone;
  icon?: string;
}) {
  return (
    <BadgeStyled $tone={tone} className="inline-flex align-items-center gap-2">
      {!!icon && <i className={`${icon} p-badge-icon`} />}
      {label}
    </BadgeStyled>
  );
}
